import { IconNames } from '@shipengine/giger-theme';
import { Typography } from '../../../components/Typography/Typography.js';
import { getListStyles, getListItemStyles, getStepStyles, getCompleteIconStyles } from './VerticalStepperStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Icon } from '../../../components/Icon/Icon.js';
import { IconSize } from '../../../components/Icon/types/size.js';

const VerticalStepper = _ref => {
  let {
    currentStep,
    onClick,
    steps,
    translations,
    ...rest
  } = _ref;
  const isPreviousStepComplete = stepIndex => stepIndex === 0 || steps[stepIndex - 1].complete;
  const handleKeyUp = (e, idx, step) => {
    if (e.key === 'Enter') {
      onClick(idx, step);
    }
  };
  return jsx("nav", {
    ...rest,
    children: jsx("ol", {
      css: getListStyles,
      children: steps.map((step, idx) => jsx("li", {
        css: getListItemStyles(idx === currentStep),
        children: jsxs(Typography, {
          component: "div",
          role: "button",
          tabIndex: isPreviousStepComplete(idx) ? 0 : -1,
          "aria-disabled": !isPreviousStepComplete(idx),
          onClick: () => onClick(idx, step),
          onKeyUp: e => handleKeyUp(e, idx, step),
          variant: idx === currentStep || step.complete ? 'subtitle1' : 'body1',
          css: getStepStyles({
            isDisabled: !isPreviousStepComplete(idx)
          }),
          children: [step.complete ? jsx(Icon, {
            css: getCompleteIconStyles,
            name: IconNames.CHECK_MARK,
            size: IconSize.SIZE_MEDIUM,
            title: translations === null || translations === void 0 ? void 0 : translations.iconTitle
          }) : undefined, step.name]
        })
      }, step.name))
    })
  });
};

export { VerticalStepper };
//# sourceMappingURL=VerticalStepper.js.map
